import { createSelector } from 'reselect';
import { findEmployerById } from 'helpers';
import { IAppState } from 'types';
import { selectEmployerById, selectEmployersRef } from './referenceSelectors';

export const selectUser = (state: IAppState) => state.user;

export const selectCurrentEmployer = createSelector(
  selectUser,
  selectEmployersRef,
  (user, employers) => {
    return findEmployerById(employers, user.employerId);
  },
);
